module.exports = __webpack_public_path__ + "static/reactredux-b351e260ab879b3fbac3fa1b7f0be9f4.png";